import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { PurchaseReport } from './purchase-report';
import { ReportingPeriod } from './reporting-period';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
/**
 * Read reporting period service.
 *
 * @author Warlock, AIS.PL
 */
var ReadReportingPeriodService = /** @class */ (function () {
    function ReadReportingPeriodService(http) {
        this.http = http;
    }
    ReadReportingPeriodService.prototype.readReportingPeriods = function (year, dealerId) {
        var url = 'dealers/' + (dealerId ? dealerId : 'mine') + '/reporting-periods/' + year + '/';
        return this.http
            .get(url, {
            headers: { 'Content-Type': 'application/json' }
        })
            .pipe(map(function (response) { return response ? response.map(function (element) { return ReportingPeriod.fromJSON(element); }) : null; }));
    };
    ReadReportingPeriodService.prototype.getReportsByWeek = function (startDate, dealerId) {
        var url = "dealers/" + (dealerId ? dealerId : 'mine') + "/reports/" + startDate.getFullYear() + "/" + (startDate.getMonth() + 1) + "/" + startDate.getDate() + "/";
        return this.http
            .get(url, {
            headers: { 'Content-Type': 'application/json' }
        })
            .pipe(map(function (response) {
            response.period = response.period ? ReportingPeriod.fromJSON(response.period) : null;
            response.reports = response.reports ? response.reports.map(function (element) { return PurchaseReport.fromJSON(element); }) : null;
            return response;
        }));
    };
    ReadReportingPeriodService.ngInjectableDef = i0.defineInjectable({ factory: function ReadReportingPeriodService_Factory() { return new ReadReportingPeriodService(i0.inject(i1.HttpClient)); }, token: ReadReportingPeriodService, providedIn: "root" });
    return ReadReportingPeriodService;
}());
export { ReadReportingPeriodService };
